module.exports = __webpack_public_path__ + "8d76163409d732f809b3b9a26503b451.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/raw-key-art-1920.jpg
// module id = 519
// module chunks = 0